import { render, staticRenderFns } from "./SaldoAwal.vue?vue&type=template&id=11d0cb4b&scoped=true"
import script from "./SaldoAwal.vue?vue&type=script&lang=js"
export * from "./SaldoAwal.vue?vue&type=script&lang=js"
import style0 from "./SaldoAwal.vue?vue&type=style&index=0&id=11d0cb4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d0cb4b",
  null
  
)

export default component.exports